import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import './phoneNumberBox.scss';
import Typography from '../../typography/Typography';
import Label from '../label/Label';
import ErrorMessage from '../errorMessage/ErrorMessage';
// type TPhoneNumberBoxProps = {
//   className?: string
//   value?: any; // Ensure value is a string
//   disabled?: boolean;
//   variant?: componentSizeVariantsEnum;
//   createProgramStep?: any;
//   inputRef?: React.Ref<HTMLInputElement>;
//   onChange?: (value?: string) => void; // Adjust the type of onChange
// } & InputHTMLAttributes<HTMLInputElement>;
const PhoneNumberBox = forwardRef<any, any>(({
  className,
  value,
  disabled,
  variant = componentSizeVariantsEnum.MEDIUM,
  createProgramStep,
  inputRef,
  isTouched = false,
  errorMessage = '',
  country = 'in',
  label = '',
  ...rest
}, ref) => {
  const handleChange = (value: string) => {
    if (rest.onChange) {
      console.log(value, 'valueeiiiieeeeee')
      rest.onChange({
        ...event,
        target: {
          ...event?.target,
          value: value
        }
      } as any);
    }
  };

  return (
    <div
      className={classNames(
        className,
        'input-field-component',
        `input-field-component--${variant}`
      )}
    >
      {label && (
        <div className='input-field-component__labelBox'>
          <Label variant={variant}>
            <span>{label}</span>
          </Label>
        </div>
      )
      }
      <PhoneInput
        {...rest}
        country={country}
        inputStyle={{ height: '42px', width: '100%' }}
        inputClass={classNames(
          className,
          'phone-number-box',
          `phone-number-box--${variant}`
        )}
        value={value}
        disabled={disabled}
        onChange={handleChange} // Use the local handleChange
        inputProps={{
          ref: ref || inputRef
        }}
      />
      {isTouched && errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
});

// Adding displayName for debugging purposes
PhoneNumberBox.displayName = 'PhoneNumberBox';

export default PhoneNumberBox;
